module.exports = __webpack_public_path__ + "static/media/essay_title_white.659ead35.png";